/* Popup fuer Sonderanfertigungen, aufgerufen aus snippets/ke-sonderanfertigung.liquid.
 *
 * Drei Dinge erledigt diese Datei:
 *
 * 1. Der Dialog wandert ans Seitenende. Die Buybox rendert bei jedem Variantenwechsel neu.
 *    Bliebe der Dialog im Block, wuerde er sich beim Wechsel der Breite schliessen und ein
 *    halb getippter Text waere weg.
 * 2. Nach einem Rerender liegt ein zweiter Dialog mit derselben Kennung im Block. Der wird
 *    verworfen, der bereits am Seitenende haengende bleibt stehen.
 * 3. Beim Absenden wird die Ruecksprungadresse auf die aktuelle Adresse gesetzt. Ohne das
 *    laedt Shopify den nackten Produktpfad: die gewaehlte Variante ist weg, und eine ueber
 *    ?view= aufgerufene Vorlage auch (in der Vorschau verschwand damit der Button).
 */
(() => {
  const init = (wrap) => {
    if (wrap.dataset.kesondInit) return;
    wrap.dataset.kesondInit = '1';

    const id = wrap.dataset.kesond;
    const frisch = wrap.querySelector('dialog[data-kesond-id]');
    const schon = document.querySelector('body > dialog[data-kesond-id="' + id + '"]');

    let dlg = schon;

    if (schon) {
      if (frisch) frisch.remove();
    } else if (frisch) {
      document.body.appendChild(frisch);
      dlg = frisch;
    }

    if (!dlg) return;

    if (!dlg.dataset.kesondGebunden) {
      dlg.dataset.kesondGebunden = '1';
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      const zu = dlg.querySelector('[data-kesond-close]');
      if (zu) zu.addEventListener('click', () => dlg.close());

      // Ruecksprung erst beim Absenden lesen: die Variante kann sich bis dahin geaendert
      // haben, das Theme schreibt sie dann per replaceState in die Adresse.
      const form = dlg.querySelector('form');
      const ziel = form && form.querySelector('[data-kesond-return]');
      if (ziel) {
        form.addEventListener('submit', () => {
          const params = new URLSearchParams(window.location.search);
          params.set('contact_posted', 'true');
          ziel.value = window.location.pathname + '?' + params.toString() + '#' + form.id;
        });
      }
    }

    wrap.querySelectorAll('[data-kesond-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
      });
    });

    // Nach dem Absenden laedt Shopify die Seite mit contact_posted=true neu. Dann soll das
    // Popup wieder aufgehen, sonst sieht niemand die Bestaetigung.
    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      if (typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
    }
  };

  let geplant = false;

  const alle = () => {
    geplant = false;
    document.querySelectorAll('[data-kesond]').forEach(init);
  };

  const plane = () => {
    if (geplant) return;
    geplant = true;
    window.requestAnimationFrame(alle);
  };

  const start = () => {
    alle();
    const info = document.querySelector('.product-info');
    if (info) new MutationObserver(plane).observe(info, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', plane);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();